import React from "react";
import FAQSection from "../../LandingComponents/Desktop/FAQ";
import Footer from "../../LandingComponents/Desktop/Footer";
import PartnerSection from "../../LandingComponents/Desktop/PartnerSection";
import ExamplesSection from "../../LandingComponents/Desktop/UserFeedback";
import ContactForm from "../../LandingComponents/Desktop/ContactForm";
import ActivationSection from "../../LandingComponents/Desktop/ActivationSection";
import WhyUs from "../../LandingComponents/Desktop/WhyUs";
import Feature from "../../LandingComponents/Desktop/Feature";
import OurPlus from "../../LandingComponents/Desktop/OurPlus";
import Cover from "../../LandingComponents/Desktop/Cover";
import Pricing from "../../LandingComponents/Desktop/Pricing";
import Header from "../../LandingComponents/Desktop/Header";
import CaseSection from "../../components/Case";
import HeaderWithBurger from "../../components/HeaderButton/headerWithBurger";

export default function LandingPage() {
    return (
        <div className="bg-[#B0B0B0]">
            <div className="md:hidden sm:hidden">
                <Header/>
            </div>
            <div className="lg:hidden">
                <HeaderWithBurger/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <Cover/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <OurPlus/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <Feature/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <WhyUs/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <ActivationSection/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <CaseSection/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <Pricing/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <ContactForm/>
            </div>
            <div className="py-20 md:py-[50px] sm:py-10">
                <ExamplesSection/>
            </div>
            {/*<div className="py-20">*/}
            {/*    <PartnerSection/>*/}
            {/*</div>*/}
            <div className="py-20 md:py-[50px] sm:py-10">
                <FAQSection/>
            </div>
            <div className="pt-20 md:pt-[50px] sm:pt-10">
                <Footer/>
            </div>
        </div>

    )
}